import { DisconnectOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useIsEdgeRestricted } from "../hooks/useEdgeMode";

interface EdgeRestrictedNoticeProps {
  /** „pos" = pos-* токените на „Маркиране" (ПИН екранът); „default" = семантичната палитра. */
  variant?: "default" | "pos";
  /** Отстъп спрямо екрана, в който стои (ПИН екранът мащабира с --u). */
  className?: string;
}

/**
 * „Локален режим — влез с код или парола" над екрана за вход и над ПИН
 * клавиатурата (§14.3.1 на договора, docs/edge.md §Ограничен локален режим).
 * Рендира се САМО в ограничен локален режим: терминалът е срещу касата, но
 * билетът му е изтекъл, докато е бил изгасен, и през касата минават само
 * двата login-а. След успешния локален вход билетът идва от касата, режимът
 * става пълен и лентата изчезва (тогава се показва `EdgeModeBanner`).
 */
export default function EdgeRestrictedNotice({
  variant = "default",
  className = "",
}: EdgeRestrictedNoticeProps) {
  const { t } = useTranslation();
  const restricted = useIsEdgeRestricted();
  if (!restricted) return null;

  const palette =
    variant === "pos"
      ? "bg-pos-offline-bg text-pos-offline-ink border-pos-offline-brd"
      : "bg-warn-tint text-warn-ink border-warn-tint2";

  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-center gap-2.5 rounded-[12px] border px-3.5 py-2.5 text-[13px] leading-[1.25] ${palette} ${className}`}
    >
      <span className="inline-flex shrink-0 items-center justify-center text-[15px]">
        <DisconnectOutlined />
      </span>
      <span
        className={`shrink-0 text-[11px] font-bold uppercase tracking-[.1em] ${
          variant === "pos" ? "font-pos-mono" : ""
        }`}
      >
        {t("edge.bannerTitle")}
      </span>
      <span aria-hidden className="h-3.5 w-px shrink-0 bg-current opacity-30" />
      <span className="min-w-0 font-semibold">
        {t("edge.bannerRestricted")}
      </span>
    </div>
  );
}
